import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { accept } from 'common/Prose/Plugins/TrackChanges/accept'
import { reject, rejectAll } from 'common/Prose/Plugins/TrackChanges/reject'
import { type EditorView } from 'prosemirror-view'
import { QueryClient } from 'react-query'
import { Layer } from 'types'
import { buildErrorMessage } from 'utils'
import { IDisposer } from './Types'

export class DefaultDisposer implements IDisposer {
  queryClient: QueryClient
  layer: Layer
  view?: EditorView

  isDispositioning: boolean = false

  constructor(queryClient: QueryClient, layer: Layer) {
    this.layer = layer
    this.queryClient = queryClient
  }

  get canAcceptChanges() {
    return this.layer?.permissions.can_merge_partial || false
  }

  get canRejectChanges() {
    return this.layer?.permissions.can_edit_content || false
  }

  setView(view?: EditorView) {
    this.view = view
  }

  accept = async (uuids: string[]) => {
    if (this.isDispositioning || !this.layer || !this.canAcceptChanges) {
      return
    }

    if (this.layer.is_main) {
      if (!this.view) {
        return
      }
      const tr = this.view.state.tr
      uuids.forEach((uuid) => accept(uuid, tr))
      this.view.dispatch(tr)
      return
    }

    this.setIsDispositioning(true)
    const response = await client.acceptChanges(this.layer.article_id, this.layer.id, uuids)
    this.setIsDispositioning(false)

    if (response?.type !== SUCCESS_RESPONSE_TYPE) {
      throw new Error(
        buildErrorMessage(response.data.errors) ||
          'An error occurred! Our team has been notified and we are looking into it.',
      )
    }
  }

  reject = (uuid: string) => {
    if (!this.canRejectChanges) {
      return
    }

    if (!this.view) {
      return
    }
    const tr = this.view.state.tr
    reject(uuid, tr)
    this.view.dispatch(tr)
  }

  rejectAll = () => {
    if (!this.view || !this.canRejectChanges) {
      return
    }
    const tr = this.view.state.tr
    rejectAll(tr)
    this.view.dispatch(tr)
  }

  setIsDispositioning(isDispositioning: boolean) {
    this.isDispositioning = isDispositioning
  }
}
